export const parseFormat = format => {
  const groups = format.split(/[^\d]/); // Разделяем группы по разделителям
  const separators = format.match(/[^\d]+/g) || []; // Находим разделители

  return {
    groups,
    separators
  };
};